
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8Q0mA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $gd8AW = parcelRequire("gd8AW");


var $erVVf = parcelRequire("erVVf");


var $f5Ulo = parcelRequire("f5Ulo");


var $cnQgR = parcelRequire("cnQgR");

const $012e0fafda229e4e$var$sourceAdType = 'crossJoin';
const $012e0fafda229e4e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    crossJoinCTA: {
        id: "loom-utils.loom-cross-sell-popup-card.crossJoinCTA",
        defaultMessage: "Try now"
    },
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    }
});
const $012e0fafda229e4e$export$9937e9f99bf53911 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t1;
    if ($[0] !== entryPointId || $[1] !== flags || $[2] !== sourceComponent) {
        t1 = {
            entryPointId: entryPointId,
            flags: flags,
            source: "loomCrossJoinPopupCard",
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        };
        $[0] = entryPointId;
        $[1] = flags;
        $[2] = sourceComponent;
        $[3] = t1;
    } else t1 = $[3];
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)(t1);
    let t2;
    if ($[4] !== stopPulse) {
        t2 = ()=>{
            stopPulse();
        };
        $[4] = stopPulse;
        $[5] = t2;
    } else t2 = $[5];
    const stopDiscoverabilityPulse = t2;
    let t3;
    if ($[6] !== entryPointId || $[7] !== experienceTracker || $[8] !== stopDiscoverabilityPulse) {
        t3 = ()=>{
            stopDiscoverabilityPulse();
            experienceTracker.succeed({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: $012e0fafda229e4e$var$sourceAdType
                }
            });
        };
        $[6] = entryPointId;
        $[7] = experienceTracker;
        $[8] = stopDiscoverabilityPulse;
        $[9] = t3;
    } else t3 = $[9];
    const onCrossJoinSuccess = t3;
    let t4;
    if ($[10] !== createAnalyticsEvent || $[11] !== entryPointId || $[12] !== onCrossJoinSuccess || $[13] !== sourceComponent || $[14] !== streamliningCrossJoinOnButtonClicked) {
        t4 = async ()=>{
            if ((0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate")) await streamliningCrossJoinOnButtonClicked(false);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "tryNow",
                    source: "loomCrossJoinPopupCard",
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[10] = createAnalyticsEvent;
        $[11] = entryPointId;
        $[12] = onCrossJoinSuccess;
        $[13] = sourceComponent;
        $[14] = streamliningCrossJoinOnButtonClicked;
        $[15] = t4;
    } else t4 = $[15];
    const onTryNowButtonClick = t4;
    let t5;
    if ($[16] !== createAnalyticsEvent || $[17] !== entryPointId || $[18] !== onCrossJoinSuccess || $[19] !== sourceActionSubjectId || $[20] !== sourceComponent || $[21] !== streamliningCrossJoinOnButtonClicked) {
        t5 = async ()=>{
            if ((0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate")) await streamliningCrossJoinOnButtonClicked(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: sourceActionSubjectId,
                    source: sourceActionSubjectId,
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[16] = createAnalyticsEvent;
        $[17] = entryPointId;
        $[18] = onCrossJoinSuccess;
        $[19] = sourceActionSubjectId;
        $[20] = sourceComponent;
        $[21] = streamliningCrossJoinOnButtonClicked;
        $[22] = t5;
    } else t5 = $[22];
    const onCrossJoinTriggerClick = t5;
    let t6;
    if ($[23] !== crossJoinHref || $[24] !== intl || $[25] !== onTryNowButtonClick) {
        t6 = (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "discovery",
            href: crossJoinHref,
            onClick: onTryNowButtonClick,
            rel: "noreferrer",
            target: "_blank"
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA));
        $[23] = crossJoinHref;
        $[24] = intl;
        $[25] = onTryNowButtonClick;
        $[26] = t6;
    } else t6 = $[26];
    let t7;
    if ($[27] !== crossJoinHref || $[28] !== onCrossJoinTriggerClick || $[29] !== triggerLink) {
        t7 = (popupTriggerProps)=>triggerLink(!(0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? crossJoinHref : "", {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            });
        $[27] = crossJoinHref;
        $[28] = onCrossJoinTriggerClick;
        $[29] = triggerLink;
        $[30] = t7;
    } else t7 = $[30];
    let t8;
    if ($[31] !== description || $[32] !== entryPointId || $[33] !== placement || $[34] !== shouldRenderToParent || $[35] !== sourceComponent || $[36] !== t6 || $[37] !== t7 || $[38] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnQgR.BaseLoomPopupCard), {
            actions: t6,
            description: description,
            entryPointId: entryPointId,
            placement: placement,
            shouldRenderToParent: shouldRenderToParent,
            title: title,
            trigger: t7,
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        });
        $[31] = description;
        $[32] = entryPointId;
        $[33] = placement;
        $[34] = shouldRenderToParent;
        $[35] = sourceComponent;
        $[36] = t6;
        $[37] = t7;
        $[38] = title;
        $[39] = t8;
    } else t8 = $[39];
    return t8;
} : ({ description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)({
        entryPointId: entryPointId,
        flags: flags,
        source: 'loomCrossJoinPopupCard',
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
    const stopDiscoverabilityPulse = (0, $cozmU.useCallback)(()=>{
        stopPulse();
    }, [
        stopPulse
    ]);
    const onCrossJoinSuccess = (0, $cozmU.useCallback)(()=>{
        stopDiscoverabilityPulse();
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: $012e0fafda229e4e$var$sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        stopDiscoverabilityPulse
    ]);
    const onTryNowButtonClick = (0, $cozmU.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'tryNow',
                source: 'loomCrossJoinPopupCard',
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    const onCrossJoinTriggerClick = (0, $cozmU.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: sourceActionSubjectId,
                source: sourceActionSubjectId,
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceActionSubjectId,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "discovery",
            href: crossJoinHref,
            onClick: onTryNowButtonClick,
            rel: "noreferrer",
            target: "_blank"
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)),
        description: description,
        entryPointId: entryPointId,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        title: title,
        trigger: (popupTriggerProps)=>// the link button behaviour is handled in streamliningCrossJoinOnButtonClicked
            // when feature gate is on for Loom crossjoin experiment
            triggerLink(!(0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? crossJoinHref : '', {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            }),
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
};
module.exports["LoomCrossJoinPopupCard"] = $012e0fafda229e4e$export$9937e9f99bf53911;

});

parcelRegister("erVVf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $eKMV3 = parcelRequire("eKMV3");


var $6mKj3 = parcelRequire("6mKj3");


var $f5Ulo = parcelRequire("f5Ulo");


var $64hvi = parcelRequire("64hvi");

const $7197be9efeb6a957$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    },
    requestAccessNote: {
        id: "loom-utils.use-streamlining-cross-join.request-access-note.content",
        defaultMessage: "Hi, admin \uD83D\uDC4B I'd like to use Loom to collaborate with my team."
    }
});
const $7197be9efeb6a957$export$76d3f97e5e2f022d = ({ entryPointId: entryPointId, flags: flags, source: source, sourceAdType: sourceAdType, sourceComponent: sourceComponent })=>{
    const intl = (0, $kSwu1.useIntl)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const requestAccess = (0, $64hvi.useRequestAccessService)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType,
        note: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessNote)
    });
    const fetchRequestAccessCapability = (0, $64hvi.useFetchRequestAccessCapability)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType
    });
    return (0, $cozmU.useCallback)(async (fromTrigger = false)=>{
        const capability = await fetchRequestAccessCapability();
        if (capability === 'REQUEST_ACCESS') {
            if ([
                'control',
                'variation'
            ].includes((0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled'))) {
                if (fromTrigger) {
                    // Open new tab for control and do nothing for variation
                    if ((0, $6mKj3.expValEquals)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'control')) window && window.open(crossJoinHref, '_blank');
                    return;
                }
                // fire manual feature exposed event for control and variation cohorts only
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'exposed',
                        actionSubject: 'feature',
                        source: source,
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            flagKey: 'twcg-1241_streamlining_loom_cross_join',
                            cohort: (0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled'),
                            fromTrigger: fromTrigger // we should always receive false here
                        }
                    }
                }).fire();
                // streamlining access request flow for variation cohort
                if ((0, $6mKj3.expValEquals)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'variation')) try {
                    const requestedAccess = await requestAccess();
                    if (requestedAccess) {
                        flags && flags.showSuccessFlag({
                            title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagTitle),
                            description: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagDescription)
                        });
                        // after successful access request, we do not proceed to open the cross join link
                        return;
                    }
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'requestAccess',
                            source: source,
                            attributes: {
                                adType: sourceAdType,
                                entrypoint: entryPointId,
                                sourceComponent: sourceComponent,
                                error: error instanceof Error ? error.message : 'unknown'
                            }
                        }
                    }).fire();
                    flags && flags.showErrorFlag({
                        title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
                            href: "https://support.atlassian.com/contact",
                            target: "_blank",
                            rel: "noreferrer"
                        }, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagActionTitle)))
                    });
                }
            }
        }
        // for other capability, we bring back the default link behaviour here
        // as we have disabled the default link behaviour for the trigger button
        window && window.open(crossJoinHref, '_blank');
    }, [
        createAnalyticsEvent,
        crossJoinHref,
        entryPointId,
        fetchRequestAccessCapability,
        flags,
        intl,
        requestAccess,
        source,
        sourceAdType,
        sourceComponent
    ]);
};
module.exports["useStreamliningCrossJoin"] = $7197be9efeb6a957$export$76d3f97e5e2f022d;

});

parcelRegister("f5Ulo", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $2VNj8 = parcelRequire("2VNj8");


var $bQm3c = parcelRequire("bQm3c");

const $3326fe0c1f9a5868$var$environmentMap = {
    DEVELOPMENT: 'dev',
    STAGING: 'stg',
    PRODUCTION: 'prod'
};
const $3326fe0c1f9a5868$export$80677895f41c9591 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const t0 = $3326fe0c1f9a5868$var$environmentMap[environment];
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $2VNj8.getATLContextDomain)("id", [
            t0,
            "commercial"
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const identityDomain = t1;
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === "PRODUCTION" ? "https://loom.com/api/auth/atlassian" : "https://stage.loom.com/api/auth/atlassian";
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
} : ()=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    // Using `environment` from session data (rather than letting `getATLContextDomain` determine it
    // internally) in order to better support local development that can be targeted at different
    // Confluence BE environments
    const identityDomain = (0, $2VNj8.getATLContextDomain)('id', [
        $3326fe0c1f9a5868$var$environmentMap[environment],
        'commercial'
    ]);
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === 'PRODUCTION' ? 'https://loom.com/api/auth/atlassian' : 'https://stage.loom.com/api/auth/atlassian';
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
};
module.exports["useLoomCrossJoinUrl"] = $3326fe0c1f9a5868$export$80677895f41c9591;

});

parcelRegister("64hvi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $VUk2d = parcelRequire("VUk2d");


var $1HeZJ = parcelRequire("1HeZJ");


var $5QBwN = parcelRequire("5QBwN");


var $6eMp2 = parcelRequire("6eMp2");


var $1ApN2 = parcelRequire("1ApN2");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $92f7d7126b973070$var$fetchJson = async (input)=>{
    const { url: url, ...options } = input;
    const response = await (0, $f7B1p.cfetch)(url, options);
    return response.json();
};
const $92f7d7126b973070$var$useRequestAccessServiceLegacy = ({ entryPointId: entryPointId, note: note, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const deps = (0, $cozmU.useMemo)(()=>({
            createAnalyticsEvent: ({ type: type, data: data })=>createAnalyticsEvent({
                    type: type,
                    data: {
                        source: source,
                        ...data
                    }
                }),
            fetchJSON: $92f7d7126b973070$var$fetchJson,
            getCurrentCloudId: ()=>cloudId,
            getCurrentUserId: ()=>userId ?? '',
            getCurrentProduct: ()=>'confluence'
        }), [
        createAnalyticsEvent,
        cloudId,
        source,
        userId
    ]);
    const requestAccess = (0, $1HeZJ.useService)((0, $5QBwN.requestAccess), deps);
    return (0, $cozmU.useCallback)(async ()=>{
        try {
            const { result: result = '' } = await requestAccess({
                product: 'loom',
                integration: entryPointId,
                note: note
            });
            const success = result === 'PENDING_REQUEST_CREATED';
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        result: result,
                        success: success
                    }
                }
            }).fire();
            return success;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        result: undefined,
                        success: false
                    }
                }
            }).fire();
            throw error;
        }
    }, [
        entryPointId,
        note,
        requestAccess,
        source,
        sourceAdType,
        createAnalyticsEvent
    ]);
};
const $92f7d7126b973070$var$useRequestAccessServiceGated = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { entryPointId: entryPointId, note: note, sourceAdType: sourceAdType } = t0;
    const requestAccess = (0, $1ApN2.useService)((0, $5QBwN.requestAccess));
    let t1;
    if ($[0] !== entryPointId || $[1] !== note || $[2] !== requestAccess || $[3] !== sourceAdType) {
        t1 = async ()=>{
            const { error: error, result: result } = await requestAccess({
                product: "loom",
                integration: entryPointId,
                note: note,
                getAdditionalAttributes: (requestAccessResult)=>({
                        adType: sourceAdType,
                        entrypoint: requestAccessResult?.integration,
                        result: requestAccessResult?.result,
                        success: requestAccessResult?.result === "PENDING_REQUEST_CREATED"
                    })
            });
            if (error) return false;
            return result === "PENDING_REQUEST_CREATED";
        };
        $[0] = entryPointId;
        $[1] = note;
        $[2] = requestAccess;
        $[3] = sourceAdType;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ entryPointId: entryPointId, note: note, sourceAdType: sourceAdType })=>{
    const requestAccess = (0, $1ApN2.useService)((0, $5QBwN.requestAccess));
    return (0, $cozmU.useCallback)(async ()=>{
        const { error: error, result: result } = await requestAccess({
            product: 'loom',
            integration: entryPointId,
            note: note,
            getAdditionalAttributes: (requestAccessResult)=>({
                    adType: sourceAdType,
                    entrypoint: requestAccessResult?.integration,
                    result: requestAccessResult?.result,
                    success: requestAccessResult?.result === 'PENDING_REQUEST_CREATED'
                })
        });
        if (error) // The platform service handles error analytics; we surface false to callers
        // instead of re-throwing to match the platform service's error contract.
        return false;
        return result === 'PENDING_REQUEST_CREATED';
    }, [
        entryPointId,
        note,
        requestAccess,
        sourceAdType
    ]);
};
const $92f7d7126b973070$export$1c1d3bfbd79d853f = (0, $VUk2d.functionWithCondition)(()=>(0, $9wGTI.fg)('expansion_services_loom_cross_join'), $92f7d7126b973070$var$useRequestAccessServiceGated, $92f7d7126b973070$var$useRequestAccessServiceLegacy);
const $92f7d7126b973070$var$useFetchRequestAccessCapabilityLegacy = ({ entryPointId: entryPointId, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $cozmU.useCallback)(async ()=>{
        const resource = `ari:cloud:loom::site/${cloudId}`;
        try {
            const params = new URLSearchParams({
                resource: resource
            });
            const url = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
            const response = await $92f7d7126b973070$var$fetchJson({
                url: url
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        resource: resource
                    }
                }
            }).fire();
            return response.results[resource] || undefined;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        resource: resource
                    }
                }
            }).fire();
        }
        return undefined;
    }, [
        cloudId,
        createAnalyticsEvent,
        entryPointId,
        source,
        sourceAdType
    ]);
};
const $92f7d7126b973070$var$useFetchRequestAccessCapabilityGated = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { entryPointId: entryPointId, sourceAdType: sourceAdType } = t0;
    const capabilitiesService = (0, $1ApN2.useService)((0, $6eMp2.fetchAccessRequestsCapabilities));
    let t1;
    if ($[0] !== capabilitiesService || $[1] !== entryPointId || $[2] !== sourceAdType) {
        t1 = async ()=>{
            const { error: error, result: result } = await capabilitiesService({
                product: "loom",
                integration: entryPointId,
                touchpoint: "Crossjoin Nudge",
                getAdditionalAttributes: (capabilitiesResult)=>({
                        adType: sourceAdType,
                        entrypoint: capabilitiesResult?.integration,
                        resource: capabilitiesResult?.resource
                    })
            });
            if (error) return;
            return result ?? undefined;
        };
        $[0] = capabilitiesService;
        $[1] = entryPointId;
        $[2] = sourceAdType;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ entryPointId: entryPointId, sourceAdType: sourceAdType })=>{
    const capabilitiesService = (0, $1ApN2.useService)((0, $6eMp2.fetchAccessRequestsCapabilities));
    return (0, $cozmU.useCallback)(async ()=>{
        const { error: error, result: result } = await capabilitiesService({
            product: 'loom',
            integration: entryPointId,
            touchpoint: 'Crossjoin Nudge',
            getAdditionalAttributes: (capabilitiesResult)=>({
                    adType: sourceAdType,
                    entrypoint: capabilitiesResult?.integration,
                    resource: capabilitiesResult?.resource
                })
        });
        if (error) return undefined;
        return result ?? undefined;
    }, [
        capabilitiesService,
        entryPointId,
        sourceAdType
    ]);
};
const $92f7d7126b973070$export$a74078d93650d63f = (0, $VUk2d.functionWithCondition)(()=>(0, $9wGTI.fg)('expansion_services_loom_cross_join'), $92f7d7126b973070$var$useFetchRequestAccessCapabilityGated, $92f7d7126b973070$var$useFetchRequestAccessCapabilityLegacy);
module.exports["useRequestAccessService"] = $92f7d7126b973070$export$1c1d3bfbd79d853f;
module.exports["useFetchRequestAccessCapability"] = $92f7d7126b973070$export$a74078d93650d63f;

});

parcelRegister("5QBwN", function(module, exports) {
/**
 * This file defines the requestAccess() service.
 */ 
var $ixfCV = parcelRequire("ixfCV");


var $7avaU = parcelRequire("7avaU");


var $2LYjf = parcelRequire("2LYjf");


var $kMx7n = parcelRequire("kMx7n");


var $6R9dB = parcelRequire("6R9dB");


var $5I0tl = parcelRequire("5I0tl");

// Dependencies - generally common to all RA's/joins:
const $611fd99d6a2b394a$var$dependencies = {
    fetchJSON: $6R9dB.fetchJSON,
    createAnalyticsEvent: $kMx7n.createAnalyticsEvent,
    fireErrorAnalytics: $5I0tl.fireErrorAnalytics,
    getStargateURL: $kMx7n.getStargateURL,
    getCurrentUserId: $kMx7n.getCurrentUserId,
    getCurrentCloudId: $kMx7n.getCurrentCloudId,
    getCurrentProduct: $kMx7n.getCurrentProduct
};
const $611fd99d6a2b394a$export$cd9e5995821603e1 = Object.assign($611fd99d6a2b394a$var$requestAccessImpl, {
    dependencies: $611fd99d6a2b394a$var$dependencies
});
async function $611fd99d6a2b394a$var$requestAccessImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    let result;
    const resource = (0, $7avaU.AnyAri).create({
        resourceType: 'site',
        resourceId: cloudId,
        resourceOwner: input.product
    }).toString();
    try {
        // https://developer.atlassian.com/platform/identity/rest/v1/api-group-access-requests/#api-v2-access-requests-request-post
        const fetchResponse = await deps.fetchJSON({
            url: deps.getStargateURL('/invitations/v1/access-requests/request'),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                ...input.note ? {
                    note: input.note
                } : {},
                metadata: {
                    sourceProduct: deps.getCurrentProduct(),
                    ...input.touchpoint ? {
                        touchpoint: input.touchpoint
                    } : {}
                }
            })
        });
        const flagEnabled = (0, $ixfCV.fg)('expansion-services-trace-id');
        const gatedTraceId = fetchResponse.traceId && flagEnabled ? fetchResponse.traceId : undefined;
        result = $611fd99d6a2b394a$var$mapRequestAccessResponse(fetchResponse.data, {
            resource: resource,
            userId: userId,
            ...input,
            traceId: gatedTraceId
        });
    } catch (error) {
        result = {
            error: (0, $2LYjf.toError)(error),
            ...input,
            result: null,
            action: null,
            resource: resource,
            userId: userId
        };
    }
    $611fd99d6a2b394a$var$fireRequestAccessAnalytics(result, context, input.getAdditionalAttributes);
    return result;
}
function $611fd99d6a2b394a$var$mapStatusToAction(status) {
    if (status === 'ACCESS_GRANTED') return 'joined';
    if (status === 'PENDING_REQUEST_CREATED') return 'requested';
    return null;
}
function $611fd99d6a2b394a$var$mapRequestAccessResponse(response, input) {
    const result = response.results[input.resource];
    return {
        error: null,
        result: result,
        action: $611fd99d6a2b394a$var$mapStatusToAction(result),
        ...input
    };
}
// Analytics functions for these common events might later become
// exported for standalone use
function $611fd99d6a2b394a$var$fireRequestAccessAnalytics(requestAccessResult, context, getAdditionalAttributes) {
    const { error: error, product: product, result: result, traceId: traceId, integration: integration, touchpoint: touchpoint, cloudId: cloudId } = requestAccessResult;
    const currentUserId = context.dependencies().getCurrentUserId();
    const baseAttributes = {
        userAaid: currentUserId,
        actorAaid: currentUserId,
        roleName: 'product/member',
        sourceProduct: context.dependencies().getCurrentProduct(),
        sourceTenantId: context.dependencies().getCurrentCloudId(),
        targetProduct: product,
        targetTenantId: cloudId ?? context.dependencies().getCurrentCloudId(),
        integration: integration,
        ...traceId ? {
            traceId: traceId
        } : {}
    };
    // touchpoint is deliberately excluded from product.joined / productAccess.requested's
    // nested `attributes`. Will consolidate when 'expansion-services-invite-capabilities' is
    // cleaned up.
    if (error) {
        if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) context.dependencies().fireErrorAnalytics({
            error: error,
            meta: {
                id: 'requestAccess'
            },
            attributes: {
                ...getAdditionalAttributes?.(requestAccessResult) ?? {},
                ...baseAttributes,
                ...touchpoint ? {
                    touchpoint: touchpoint
                } : {}
            }
        });
        return;
    }
    if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) $611fd99d6a2b394a$var$fireRequestAccessSucceeded({
        ...getAdditionalAttributes?.(requestAccessResult) ?? {},
        ...baseAttributes,
        ...touchpoint ? {
            touchpoint: touchpoint
        } : {}
    }, context);
    const attributes = {
        ...baseAttributes,
        inviteStatus: result
    };
    if (result === 'ACCESS_GRANTED') {
        $611fd99d6a2b394a$var$fireProductJoined(attributes, context, touchpoint);
        return;
    }
    if (!(0, $ixfCV.fg)('expansion-services-invite-capabilities') || result === 'PENDING_REQUEST_CREATED') {
        $611fd99d6a2b394a$var$fireProductAccessRequested(attributes, context, touchpoint);
        return;
    }
}
function $611fd99d6a2b394a$var$fireProductAccessRequested(attributes, context, touchpoint) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSubjectId: attributes.targetProduct,
            source: touchpoint ?? (0, $kMx7n.EnablementTouchpoint).UNKNOWN,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $611fd99d6a2b394a$var$fireProductJoined(attributes, context, touchpoint) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'product',
            action: 'joined',
            actionSubjectId: attributes.targetProduct,
            source: touchpoint ?? (0, $kMx7n.EnablementTouchpoint).UNKNOWN,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $611fd99d6a2b394a$var$fireRequestAccessSucceeded(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'requestAccess',
            action: 'succeeded',
            source: attributes.touchpoint ?? (0, $kMx7n.EnablementTouchpoint).UNKNOWN,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
module.exports["requestAccess"] = $611fd99d6a2b394a$export$cd9e5995821603e1;

});

parcelRegister("6eMp2", function(module, exports) {
/**
 * This file defines the fetchAccessRequestsCapabilities() service.
 * https://hello.atlassian.net/wiki/spaces/ETRUST/pages/626729299/API+Guide+-+v1+access-requests+capabilities
 */ 
var $ixfCV = parcelRequire("ixfCV");


var $7avaU = parcelRequire("7avaU");


var $2LYjf = parcelRequire("2LYjf");


var $kMx7n = parcelRequire("kMx7n");


var $6R9dB = parcelRequire("6R9dB");


var $5I0tl = parcelRequire("5I0tl");

const $e13ee81b60f2c25b$export$142e3ccf43b34609 = (accessMode, verificationStatus)=>{
    switch(accessMode){
        case 'ACCESS_EXISTS':
            return 'ACCESS_EXISTS';
        case 'DIRECT_ACCESS':
            return verificationStatus === 'REQUIRED' ? 'VERIFICATION_REQUIRED' : 'CAN_JOIN';
        case 'REQUEST_ACCESS':
            return verificationStatus === 'REQUIRED' ? 'VERIFICATION_REQUIRED' : 'CAN_REQUEST';
        default:
            return 'CANNOT_REQUEST_ACCESS';
    }
};
// Dependencies
const $e13ee81b60f2c25b$var$dependencies = {
    fetchJSON: $6R9dB.fetchJSON,
    createAnalyticsEvent: $kMx7n.createAnalyticsEvent,
    getCurrentCloudId: $kMx7n.getCurrentCloudId,
    getCurrentProduct: $kMx7n.getCurrentProduct,
    getCurrentUserId: $kMx7n.getCurrentUserId,
    getStargateURL: $kMx7n.getStargateURL
};
const $e13ee81b60f2c25b$export$bf3c7ce8c1124ff = Object.assign($e13ee81b60f2c25b$var$fetchAccessRequestsCapabilitiesImpl, {
    dependencies: $e13ee81b60f2c25b$var$dependencies
});
async function $e13ee81b60f2c25b$var$fetchAccessRequestsCapabilitiesImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    const role = input.role ?? 'product/member';
    let result;
    const resource = (0, $7avaU.AnyAri).create({
        resourceType: 'site',
        resourceId: cloudId,
        resourceOwner: input.product
    }).toString();
    try {
        const url = deps.getStargateURL(`/invitations/v1/access-requests/capabilities?resource=${resource}`);
        const response = await deps.fetchJSON({
            url: url
        });
        result = $e13ee81b60f2c25b$var$mapAccessRequestsCapabilitiesResponse(response.data, {
            ...input,
            resource: resource,
            userId: userId,
            role: role,
            traceId: response.traceId
        });
    } catch (error) {
        result = {
            error: (0, $2LYjf.toError)(error),
            ...input,
            resource: resource,
            userId: userId,
            role: role,
            result: null,
            capability: null
        };
    }
    $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesAnalytics(result, context);
    return result;
}
function $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesAnalytics(result, context) {
    const { error: error, result: accessMode, product: product, integration: integration, role: role, userId: userId, touchpoint: touchpoint, traceId: traceId, getAdditionalAttributes: getAdditionalAttributes } = result;
    const targetTenantId = result.cloudId ?? context.dependencies().getCurrentCloudId();
    const baseAttributes = {
        ...getAdditionalAttributes?.(result) ?? {},
        actorAaid: userId,
        integration: integration,
        roleName: role,
        sourceProduct: context.dependencies().getCurrentProduct(),
        sourceTenantId: context.dependencies().getCurrentCloudId(),
        targetProduct: product,
        targetTenantId: targetTenantId,
        touchpoint: touchpoint,
        ...traceId ? {
            traceId: traceId
        } : {},
        userAaid: userId
    };
    if (error) {
        $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesFailed(baseAttributes, context, error);
        return;
    }
    $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesSucceeded({
        ...baseAttributes,
        accessMode: accessMode
    }, context);
    return;
}
function $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesSucceeded(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'fetchAccessRequestsCapabilities',
            action: 'succeeded',
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesFailed(attributes, context, error) {
    if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) {
        (0, $5I0tl.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'fetchAccessRequestsCapabilities'
            },
            attributes: attributes
        }, context);
        return;
    }
    const fireErrorAnalytics = context.dependencies().fireErrorAnalytics;
    if (fireErrorAnalytics) {
        fireErrorAnalytics({
            error: error,
            meta: {
                id: 'fetchAccessRequestsCapabilities'
            },
            attributes: attributes
        });
        return;
    }
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'fetchAccessRequestsCapabilities',
            action: 'failed',
            source: attributes.touchpoint,
            attributes: {
                ...attributes,
                message: error.message
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $e13ee81b60f2c25b$var$mapAccessRequestsCapabilitiesResponse(response, input) {
    const result = response.resultsV2[input.resource]?.find(({ role: role })=>role === input.role)?.accessMode;
    if (!result) return {
        error: new Error(`No access request capability found for the given resource: ${input.resource} and role: ${input.role}`),
        result: null,
        capability: null,
        ...input
    };
    return {
        error: null,
        result: result,
        capability: $e13ee81b60f2c25b$export$142e3ccf43b34609(result, response.verificationStatus),
        ...input
    };
}
module.exports["fetchAccessRequestsCapabilities"] = $e13ee81b60f2c25b$export$bf3c7ce8c1124ff;

});

parcelRegister("cnQgR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4nIKB = parcelRequire("4nIKB");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $bltJZ = parcelRequire("bltJZ");


var $5wHqn = parcelRequire("5wHqn");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $2wCqQ = parcelRequire("2wCqQ");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $dOlTT = parcelRequire("dOlTT");

var $9Zall = parcelRequire("9Zall");

var $8jXZv = parcelRequire("8jXZv");

var $3eYzF = parcelRequire("3eYzF");

var $uyMbP = parcelRequire("uyMbP");

var $gi4qj = parcelRequire("gi4qj");

var $4AC39 = parcelRequire("4AC39");

var $l3ydK = parcelRequire("l3ydK");

var $2Vz7H = parcelRequire("2Vz7H");

var $6VFk2 = parcelRequire("6VFk2");

var $6OwHS = parcelRequire("6OwHS");

var $2K2hA = parcelRequire("2K2hA");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $9aU7l = parcelRequire("9aU7l");


var $ehWBB = parcelRequire("ehWBB");


var $8unIh = parcelRequire("8unIh");

const $282df3a04f7add9c$export$e4ecefef0a48fd72 = 400;
const $282df3a04f7add9c$var$i18n = (0, $kSwu1.defineMessages)({
    tryNow: {
        id: "loom-utils.loom-cross-sell-popup-card.tryNow",
        defaultMessage: "Try now"
    }
});
const $282df3a04f7add9c$var$cardStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    overflow: 'auto',
    width: '352px'
});
const $282df3a04f7add9c$var$cardContentStyles = (0, $buxP3.xcss)({
    padding: 'space.300'
});
const $282df3a04f7add9c$var$imageContainerStyles = (0, $buxP3.xcss)({
    height: '201px'
});
const $282df3a04f7add9c$var$spotlightContentContainerStyles = (0, $buxP3.xcss)({
    position: 'fixed'
});
const $282df3a04f7add9c$export$48e89f1cdc429537 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(83);
    const { actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: t1, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl } = t0;
    const shouldRenderToParent = t1 === undefined ? true : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const isDarkMode = colorMode === "dark";
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const hasStartedPreloadingImage = (0, $cozmU.useRef)(false);
    const closePopupTimerRef = (0, $cozmU.useRef)(null);
    const openPopupTimerRef = (0, $cozmU.useRef)(null);
    const contentWrapperElementRef = (0, $cozmU.useRef)(null);
    const triggerElementRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (closePopupTimerRef.current) {
                clearTimeout(closePopupTimerRef.current);
                closePopupTimerRef.current = null;
            }
        };
        $[0] = t2;
    } else t2 = $[0];
    const clearClosePopupTimer = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (openPopupTimerRef.current) {
                clearTimeout(openPopupTimerRef.current);
                openPopupTimerRef.current = null;
            }
        };
        $[1] = t3;
    } else t3 = $[1];
    const clearOpenPopupTimer = t3;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t4;
    let t5;
    if ($[2] !== entryPointId || $[3] !== experienceTracker || $[4] !== isOpen || $[5] !== sourceAdType) {
        t4 = ()=>{
            if (isOpen) experienceTracker.start({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
        };
        t5 = [
            entryPointId,
            experienceTracker,
            isOpen,
            sourceAdType
        ];
        $[2] = entryPointId;
        $[3] = experienceTracker;
        $[4] = isOpen;
        $[5] = sourceAdType;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[8] !== entryPointId || $[9] !== experienceTracker || $[10] !== sourceAdType) {
        t6 = ()=>{
            setIsOpen(false);
            experienceTracker.abort({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                reason: "Loom pop up closed",
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
        };
        $[8] = entryPointId;
        $[9] = experienceTracker;
        $[10] = sourceAdType;
        $[11] = t6;
    } else t6 = $[11];
    const safeClosePopup = t6;
    let t7;
    if ($[12] !== safeClosePopup) {
        t7 = ()=>{
            clearOpenPopupTimer();
            if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
                safeClosePopup();
                closePopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[12] = safeClosePopup;
        $[13] = t7;
    } else t7 = $[13];
    const startClosePopupTimer = t7;
    let t8;
    if ($[14] !== createAnalyticsEvent || $[15] !== entryPointId || $[16] !== sourceAdType || $[17] !== sourceComponent) {
        t8 = ()=>{
            clearClosePopupTimer();
            if (!hasStartedPreloadingImage.current) {
                hasStartedPreloadingImage.current = true;
                const img = new Image();
                img.src = (0, (/*@__PURE__*/$parcel$interopDefault($9aU7l)));
            }
            if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
                createAnalyticsEvent({
                    type: "sendScreenEvent",
                    data: {
                        name: "loomAdPopupCard",
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
                setIsOpen(true);
                openPopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[14] = createAnalyticsEvent;
        $[15] = entryPointId;
        $[16] = sourceAdType;
        $[17] = sourceComponent;
        $[18] = t8;
    } else t8 = $[18];
    const startOpenPopupTimer = t8;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            clearOpenPopupTimer();
        };
        $[19] = t9;
    } else t9 = $[19];
    const handleTriggerBlur = t9;
    let t10;
    if ($[20] !== startOpenPopupTimer) {
        t10 = ()=>{
            startOpenPopupTimer();
        };
        $[20] = startOpenPopupTimer;
        $[21] = t10;
    } else t10 = $[21];
    const handleTriggerMouseEnter = t10;
    let t11;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>{
            clearClosePopupTimer();
        };
        $[22] = t11;
    } else t11 = $[22];
    const handleCardMouseEnter = t11;
    let t12;
    if ($[23] !== startClosePopupTimer) {
        t12 = ()=>{
            if (!contentWrapperElementRef.current?.contains(document.activeElement) && document.activeElement !== triggerElementRef.current) startClosePopupTimer();
        };
        $[23] = startClosePopupTimer;
        $[24] = t12;
    } else t12 = $[24];
    const handleMouseLeave = t12;
    let t13;
    if ($[25] !== actions || $[26] !== description || $[27] !== handleMouseLeave || $[28] !== title) {
        t13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: contentWrapperElementRef,
                xcss: $282df3a04f7add9c$var$cardStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $282df3a04f7add9c$var$imageContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                alt: "",
                height: "201px",
                width: "352px",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9aU7l)))
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.300",
                xcss: $282df3a04f7add9c$var$cardContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                as: "h2",
                size: "small"
            }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                as: "p",
                color: "color.text.subtle"
            }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                alignBlock: "center",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.LoomAttributionLogo), {
                appearance: "brand",
                size: "medium"
            }), actions)));
        $[25] = actions;
        $[26] = description;
        $[27] = handleMouseLeave;
        $[28] = title;
        $[29] = t13;
    } else t13 = $[29];
    const content = t13;
    if (sourceAdType === "crossFlow") {
        let t14;
        if ($[30] !== handleMouseLeave || $[31] !== handleTriggerMouseEnter || $[32] !== isOpen || $[33] !== trigger) {
            t14 = trigger({
                ref: triggerElementRef,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                "aria-expanded": isOpen,
                "aria-haspopup": true
            });
            $[30] = handleMouseLeave;
            $[31] = handleTriggerMouseEnter;
            $[32] = isOpen;
            $[33] = trigger;
            $[34] = t14;
        } else t14 = $[34];
        let t15;
        if ($[35] !== t14) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, t14);
            $[35] = t14;
            $[36] = t15;
        } else t15 = $[36];
        const t16 = spotlightPlacement || "left-start";
        let t17;
        if ($[37] !== title) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                as: "span",
                size: "xsmall"
            }, title);
            $[37] = title;
            $[38] = t17;
        } else t17 = $[38];
        let t18;
        if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null);
            $[39] = t18;
        } else t18 = $[39];
        let t19;
        if ($[40] !== adControl) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, t18, adControl);
            $[40] = adControl;
            $[41] = t19;
        } else t19 = $[41];
        let t20;
        if ($[42] !== t17 || $[43] !== t19) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, t17, t19);
            $[42] = t17;
            $[43] = t19;
            $[44] = t20;
        } else t20 = $[44];
        const t21 = isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($8unIh))) : (0, (/*@__PURE__*/$parcel$interopDefault($ehWBB)));
        let t22;
        if ($[45] !== t21) {
            t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                alt: "",
                src: t21
            }));
            $[45] = t21;
            $[46] = t22;
        } else t22 = $[46];
        let t23;
        if ($[47] !== description) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                as: "p"
            }, description));
            $[47] = description;
            $[48] = t23;
        } else t23 = $[48];
        let t24;
        if ($[49] !== intl) {
            t24 = intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow);
            $[49] = intl;
            $[50] = t24;
        } else t24 = $[50];
        let t25;
        if ($[51] !== primaryOnClick || $[52] !== t24) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
                onClick: primaryOnClick
            }, t24)));
            $[51] = primaryOnClick;
            $[52] = t24;
            $[53] = t25;
        } else t25 = $[53];
        let t26;
        if ($[54] !== t20 || $[55] !== t22 || $[56] !== t23 || $[57] !== t25) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
                testId: "loom-cross-sell-spotlight-content-card"
            }, t20, t22, t23, t25);
            $[54] = t20;
            $[55] = t22;
            $[56] = t23;
            $[57] = t25;
            $[58] = t26;
        } else t26 = $[58];
        let t27;
        if ($[59] !== isOpen || $[60] !== safeClosePopup || $[61] !== t16 || $[62] !== t26) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
                isVisible: isOpen,
                placement: t16,
                dismiss: safeClosePopup,
                testId: "loom-cross-sell-spotlight-content",
                strategy: "absolute",
                shouldDismissOnClickOutside: false
            }, t26);
            $[59] = isOpen;
            $[60] = safeClosePopup;
            $[61] = t16;
            $[62] = t26;
            $[63] = t27;
        } else t27 = $[63];
        let t28;
        if ($[64] !== handleMouseLeave || $[65] !== t27) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                ref: triggerElementRef,
                testId: "loom-cross-sell-spotlight-content-container",
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
            }, t27);
            $[64] = handleMouseLeave;
            $[65] = t27;
            $[66] = t28;
        } else t28 = $[66];
        let t29;
        if ($[67] !== t15 || $[68] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, t15, t28);
            $[67] = t15;
            $[68] = t28;
            $[69] = t29;
        } else t29 = $[69];
        return t29;
    }
    const t14 = placement || "auto";
    let t15;
    if ($[70] !== handleMouseLeave || $[71] !== handleTriggerMouseEnter || $[72] !== isOpen || $[73] !== trigger) {
        t15 = (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4nIKB.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            });
        $[70] = handleMouseLeave;
        $[71] = handleTriggerMouseEnter;
        $[72] = isOpen;
        $[73] = trigger;
        $[74] = t15;
    } else t15 = $[74];
    let t16;
    if ($[75] !== content || $[76] !== isOpen || $[77] !== safeClosePopup || $[78] !== shouldRenderToParent || $[79] !== t14 || $[80] !== t15 || $[81] !== title) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            autoFocus: false,
            content: content,
            isOpen: isOpen,
            label: title,
            onClose: safeClosePopup,
            placement: t14,
            role: "dialog",
            shouldRenderToParent: shouldRenderToParent,
            trigger: t15
        });
        $[75] = content;
        $[76] = isOpen;
        $[77] = safeClosePopup;
        $[78] = shouldRenderToParent;
        $[79] = t14;
        $[80] = t15;
        $[81] = title;
        $[82] = t16;
    } else t16 = $[82];
    return t16;
} : ({ actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: shouldRenderToParent = true, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const isDarkMode = colorMode === 'dark';
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const hasStartedPreloadingImage = (0, $cozmU.useRef)(false);
    const closePopupTimerRef = (0, $cozmU.useRef)(null);
    const openPopupTimerRef = (0, $cozmU.useRef)(null);
    const contentWrapperElementRef = (0, $cozmU.useRef)(null);
    const triggerElementRef = (0, $cozmU.useRef)(null);
    const clearClosePopupTimer = (0, $cozmU.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const clearOpenPopupTimer = (0, $cozmU.useCallback)(()=>{
        if (openPopupTimerRef.current) {
            clearTimeout(openPopupTimerRef.current);
            openPopupTimerRef.current = null;
        }
    }, []);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        if (isOpen) experienceTracker.start({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        isOpen,
        sourceAdType
    ]);
    const safeClosePopup = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'Loom pop up closed',
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        sourceAdType
    ]);
    const startClosePopupTimer = (0, $cozmU.useCallback)(()=>{
        clearOpenPopupTimer();
        if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
            safeClosePopup();
            closePopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearOpenPopupTimer,
        safeClosePopup
    ]);
    /**
   * Don't open the popup card immediately on hover or focus
   *
   * 1) Focus: We want KB users to be able to quickly navigate through areas with entrypoints that
   * are alongside many other UI controls (e.g., Page Header, Page Editor Toolbar) without triggering
   * the popup card and getting "stuck" (needing to hit "esc" to continue).
   *
   * 2) Hover: We don't want users to feel like the popup card gets in their way of clicking other
   * things in the UI just because their mouse briefly brushed over the entrypoint button.
   *
   * This was heavily inspired by the hover cards used in the Page Tree (`useHoverPageCard`)
   */ const startOpenPopupTimer = (0, $cozmU.useCallback)(()=>{
        clearClosePopupTimer();
        if (!hasStartedPreloadingImage.current) {
            hasStartedPreloadingImage.current = true;
            const img = new Image();
            img.src = (0, (/*@__PURE__*/$parcel$interopDefault($9aU7l)));
        }
        if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'loomAdPopupCard',
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            setIsOpen(true);
            openPopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearClosePopupTimer,
        createAnalyticsEvent,
        entryPointId,
        sourceAdType,
        sourceComponent
    ]);
    const handleTriggerBlur = (0, $cozmU.useCallback)(()=>{
        clearOpenPopupTimer();
    }, [
        clearOpenPopupTimer
    ]);
    const handleTriggerMouseEnter = (0, $cozmU.useCallback)(()=>{
        startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleCardMouseEnter = (0, $cozmU.useCallback)(()=>{
        clearClosePopupTimer();
    }, [
        clearClosePopupTimer
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        /**
     * Don't close the popup card when moving the mouse outside of it (or the trigger) if something
     * inside it (or the trigger itself) is focused
     */ if (// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        !contentWrapperElementRef.current?.contains(document.activeElement) && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.activeElement !== triggerElementRef.current) startClosePopupTimer();
    }, [
        startClosePopupTimer
    ]);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            onMouseEnter: handleCardMouseEnter,
            onMouseLeave: handleMouseLeave,
            ref: contentWrapperElementRef,
            xcss: $282df3a04f7add9c$var$cardStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $282df3a04f7add9c$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: "",
            height: "201px",
            width: "352px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9aU7l)))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.300",
            xcss: $282df3a04f7add9c$var$cardContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "small"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            as: "p",
            color: "color.text.subtle"
        }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.LoomAttributionLogo), {
            appearance: "brand",
            size: "medium"
        }), actions)));
    if (sourceAdType === 'crossFlow') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, trigger({
        ref: triggerElementRef,
        isSelected: isOpen,
        onBlur: handleTriggerBlur,
        onMouseEnter: handleTriggerMouseEnter,
        onMouseLeave: handleMouseLeave,
        'aria-expanded': isOpen,
        'aria-haspopup': true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        ref: triggerElementRef,
        testId: "loom-cross-sell-spotlight-content-container",
        onMouseEnter: handleCardMouseEnter,
        onMouseLeave: handleMouseLeave,
        xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        isVisible: isOpen,
        placement: spotlightPlacement || 'left-start',
        dismiss: safeClosePopup,
        testId: "loom-cross-sell-spotlight-content",
        strategy: "absolute",
        shouldDismissOnClickOutside: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "loom-cross-sell-spotlight-content-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "span",
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null), adControl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($8unIh))) : (0, (/*@__PURE__*/$parcel$interopDefault($ehWBB)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: primaryOnClick
    }, intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        autoFocus: false,
        content: content,
        isOpen: isOpen,
        /**
   * Using `titleId` and adding the same value as an `id` to the Heading in the popup content
   * does not announce properly in macOS VoiceOver
   */ label: title,
        onClose: safeClosePopup,
        placement: placement || 'auto',
        role: "dialog",
        shouldRenderToParent: shouldRenderToParent,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4nIKB.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            })
    });
};
module.exports["BaseLoomPopupCard"] = $282df3a04f7add9c$export$48e89f1cdc429537;

});

parcelRegister("9aU7l", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImage.6e60c328.png", import.meta.url).toString();

});

parcelRegister("ehWBB", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Light.55587eef.png", import.meta.url).toString();

});

parcelRegister("8unIh", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Dark.c1c1769c.png", import.meta.url).toString();

});


//# sourceMappingURL=GlobalCreateContentPopoverMenu.60156109.js.map
